import React, { Suspense, useEffect, useState } from 'react';

const NavbarPage = React.lazy(() => import('../../components/Navbar/Navbar_Page'));
const Section    = React.lazy(() => import('./Section'));
const Service    = React.lazy(() => import('../../components/Service/service'));
const About      = React.lazy(() => import('../../components/About/about'));
const Counter    = React.lazy(() => import('../../components/Counter/counter'));
const Feature    = React.lazy(() => import('../../components/Features/feature'));
const GetInTouch = React.lazy(() => import('../../components/GetInTouch/GetInTouch'));
const Footer     = React.lazy(() => import('../../components/Footer/footer'));

const navItems = [
  { id: 1, idnm: 'home',         navheading: 'Home' },
  { id: 2, idnm: 'services',     navheading: 'Focus' },
  { id: 3, idnm: 'about',        navheading: 'About' },
  { id: 4, idnm: 'technologies', navheading: 'Ecosystem' },
  { id: 5, idnm: 'process',      navheading: 'Approach' },
  { id: 6, idnm: 'contact',      navheading: 'Contact' },
];

const Loader = () => (
  <div id="preloader">
    <div id="status">
      <div className="spinner">
        <div className="dot1"></div>
        <div className="dot2"></div>
      </div>
    </div>
  </div>
);

const Layout1 = () => {
  const [navClass, setNavClass] = useState('');

  useEffect(() => {
    const onScroll = () => {
      setNavClass(window.scrollY > 80 ? 'nav-sticky' : '');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <NavbarPage navItems={navItems} navClass={navClass} />
      <Section />
      <Service />
      <About />
      <Counter />
      <Feature />
      <GetInTouch />
      <Footer />
    </Suspense>
  );
};

export default Layout1;
